import { CLEAR_DATA, UPDATE_HAS_FEATURE_DOC, UPDATE_STATUS } from "./actionTypes";

export const updateStatusSuccess = newStatus => ({
  type: UPDATE_STATUS,
  payload: newStatus,
});

export const updateHasFeatureSuccess = newState => ({
  type: UPDATE_HAS_FEATURE_DOC,
  payload: newState,
});

export const clearData = () => ({
  type: CLEAR_DATA,
});
